export const ENTITY = 'FUNCTION_REGISTER';